import React from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { calculateSmsLenghtAndCount, smsContainsUrl } from "../utils/sms-utils";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import RecipientSelector from "./RecipientSelector";

import { submitNotification } from "../api/notifications";
import { getStatistics } from "../api/stats";
import Loading from "./Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import fontawesome from "@fortawesome/fontawesome";
import {
  faAngleDown,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faCheck,
  faTimes,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";

fontawesome.library.add(
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faAngleDown,
  faCheck,
  faTimes,
  faSpinner
);

const sampleURL = "\nhttps://smic.boss.siemens.cloud/rsp?k=IwGmDZiAdkbhas";

class NewNotification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      smsLnS: calculateSmsLenghtAndCount(""),
      ExpectedResponses: [],
      allowOpenText: false,
      allowMultipleChoice: false,
      isInteractive: false,
      scheduleDate: undefined,
      respondUntil: undefined,
      _tmp_scheduleDate: undefined,
      _tmp_respondUntil: undefined,
      recipients: undefined,
      recipientsCount: 0,
      __tmpExpectedAnswer: "",
      __inputValidation: [],
      stats: undefined,
      isSubmitting: false,
    };

  }

  fetchStats = () => {
    getStatistics().then((res) => {
      this.setState({ stats: res });
    });
  };

  componentDidMount() {
    this.fetchStats();
  }

  addExpectedResponse = (text) => {
    if (!this.state.ExpectedResponses.map((er) => er.text).includes(text)) {
      this.setState({
        ExpectedResponses: [...this.state.ExpectedResponses, { text: text }],
      });
    }
    this.setState({ __tmpExpectedAnswer: "" });
  };

  removeExpectedResponse = (text) => {
    this.setState({
      ExpectedResponses: this.state.ExpectedResponses.filter(
        (t) => t.text !== text
      ),
    });
  };

  onToggleInteractivity = () => {
    this.updateSmsLength(this.state.smsLnS.text, !this.state.isInteractive);
    this.setState({ isInteractive: !this.state.isInteractive });
  };

  updateSmsLength = (message, interactive = undefined) => {
    let additionalLength;
    if (interactive !== undefined) {
      additionalLength = interactive ? sampleURL.length : 0;
    } else {
      additionalLength = this.state.isInteractive ? sampleURL.length : 0;
    }
    this.setState({
      smsLnS: calculateSmsLenghtAndCount(message, additionalLength),
    });
  };

  validateInputs = () => {
    const validationErrors = [];

    if (this.state.title.length === 0)
      validationErrors.push("The title can't be empty.");
    if (this.state.smsLnS.text.length === 0)
      validationErrors.push("The message can't be empty.");

    if (this.state.scheduleDate && this.state.scheduleDate.isBefore(moment()))
      validationErrors.push("The scheduled date must be in the future.");

    if (
      this.state.respondUntil &&
      ((this.state.scheduleDate &&
        this.state.respondUntil.isSameOrBefore(this.state.scheduleDate)) ||
        (!this.state.scheduleDate &&
          this.state.respondUntil.isSameOrBefore(moment())))
    )
      validationErrors.push(
        "The 'respond until' date must be after the 'scheduled to send' date."
      );

    if (!this.state.recipients || this.state.recipients.length === 0)
      validationErrors.push("Atleast one recipient group must be specified.");

    this.setState({ __inputValidation: validationErrors });
    return validationErrors;
  };

  onSelectRecipients = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <RecipientSelector
            onClose={onClose}
            onConfirm={(recipients, count) =>
              this.setState({ recipients: recipients, recipientsCount: count })
            }
            existingRecipients={this.state.recipients}
          />
        );
      },
    });
  };

  onSubmit = () => {
    if (this.validateInputs().length > 0) return;

    this.setState({ isSubmitting: true });

    submitNotification({
      title: this.state.title,
      message: this.state.smsLnS.text,
      recipients: this.state.recipients,
      recipientsCount: this.state.recipientsCount,
      allowOpenText: this.state.allowOpenText,
      allowMultipleChoice: this.state.allowMultipleChoice,
      sentAt: this.state.scheduleDate ? this.state.scheduleDate : null,
      respondUntil: this.state.respondUntil ? this.state.respondUntil : null,
      ExpectedResponses: this.state.ExpectedResponses,
    }).then((res) => {
      this.props.history.push("/notifications");
    });
  };

  render() {
    const stats = this.state.stats;

    const renderExpectedResponse = (text) => {
      return (
        <div key={text} className="control">
          <div className="tags has-addons">
            <span className="tag is-info">{text}</span>
            <span
              onClick={() => this.removeExpectedResponse(text)}
              className="tag is-info is-delete"
            >
              X
            </span>
          </div>
        </div>
      );
    };

    const renderSmsLimitWarning = () => {
      const FACTOR_OF_USERS_MISS_DEADLINE = 0.5;
      const FACTOR_OF_USERS_GIVE_WRONG_ANSWER = 0.2;

      if (
        this.state.recipientsCount > 0 &&
        this.state.stats.smsLimitRemaining
      ) {
        const recCount = this.state.recipientsCount;
        const smsCount = this.state.smsLnS.smsCount;

        const wrongAnswerCount =
          recCount *
          (this.state.ExpectedResponses.length > 0 && !this.state.allowOpenText
            ? FACTOR_OF_USERS_GIVE_WRONG_ANSWER
            : 0);
        const missDeadlineCount =
          recCount *
          (this.state.respondUntil ? FACTOR_OF_USERS_MISS_DEADLINE : 0);

        const estimatedSMS =
          recCount * smsCount + wrongAnswerCount + missDeadlineCount;

        const inCost = this.state.stats.costPerInboundSMS;
        const outCost = this.state.stats.costPerOutboundSMS;

        const estimatedCost =
          recCount * smsCount * outCost +
          (this.state.ExpectedResponses.length > 0 && !this.state.allowOpenText
            ? recCount * inCost
            : 0) +
          wrongAnswerCount * (inCost + outCost) +
          missDeadlineCount * outCost;

        if (estimatedSMS > this.state.stats.smsLimitRemaining) {
          return (
            <>
              <p className="has-text-danger">
                This notification will likely exceed the daily limit for SMS and
                may cause the network operator to block outgoing messages.
              </p>
              <p className="has-text-danger">
                Please consider postponing this notification for tomorrow or
                reducing the number of recipients.
              </p>
            </>
          );
        }

        if (estimatedCost > this.state.stats.remainingSpending) {
          return (
            <>
              <p className="has-text-danger">
                This notification will likely exceed the monthly spending quote
                available for SMS and some or all employees will not receive
                this notification.
              </p>
              <p className="has-text-danger">
                Please consider postponing this notification or reducing the
                number of recipients.
              </p>
            </>
          );
        }
      }
    };

    const renderSpendingQuota = () => {
      if (!this.state.stats) return;

      const remMonthlySpending =
        (this.state.stats.remainingSpending / this.state.stats.costLimit) * 100;
      const remSmsLimit =
        (this.state.stats.smsLimitRemaining / this.state.stats.smsLimit) * 100;

      const getIcon = (percent) => {
        if (percent > 80) return "battery-full";
        if (percent > 60) return "battery-three-quarters";
        if (percent > 40) return "battery-half";
        if (percent > 20) return "battery-quarter";
        return "battery-empty";
      };

      const getColor = (percent) => {
        if (percent > 80) return "#009999";
        if (percent > 60) return "#8ac900";
        if (percent > 40) return "#c9ae00";
        if (percent > 20) return "#c96b00";
        return "#c90d00";
      };

      return (
        <div className="field mb-6">
          <label className="label">Quotas</label>

          <p className="mb-2">
            Remaining monthly spending -{" "}
            <span style={{ color: getColor(remMonthlySpending) }}>
              {remMonthlySpending.toFixed(2)}%{" "}
              <FontAwesomeIcon icon={getIcon(remMonthlySpending)} />
            </span>
          </p>
          <p className="mb-4">
            Remaining daily SMS -{" "}
            <span style={{ color: getColor(remSmsLimit) }}>
              {remSmsLimit.toFixed(2)}%{" "}
              <FontAwesomeIcon icon={getIcon(remSmsLimit)} />
            </span>
          </p>
        </div>
      );
    };

    const renderResponsesSection = () => {
      return (
        <>
          {/* EXPECTED RESPONSES */}

          <div className="field mt-6">
            <label className="label">Responses</label>

            <p className="mb-4">
              Include a set of expected responses and we'll display the
              aggregated results.
            </p>

            <div className="field has-addons">
              <div className="control">
                <input
                  className="input"
                  type="text"
                  placeholder="Add a response"
                  value={this.state.__tmpExpectedAnswer}
                  onChange={(e) =>
                    this.setState({
                      __tmpExpectedAnswer: e.target.value.toUpperCase(),
                    })
                  }
                  onKeyDown={(e) => {
                    e.key === "Enter" &&
                      e.target.value.length > 0 &&
                      this.addExpectedResponse(e.target.value.toUpperCase());
                  }}
                />
              </div>
              <div className="control">
                <button
                  className="button is-info"
                  onClick={() =>
                    this.addExpectedResponse(this.state.__tmpExpectedAnswer)
                  }
                  disabled={this.state.__tmpExpectedAnswer.length === 0}
                >
                  Add
                </button>
              </div>
            </div>

            <div className="field is-grouped is-grouped-multiline mt-5 mb-5">
              {this.state.ExpectedResponses.map((er) =>
                renderExpectedResponse(er.text)
              )}
            </div>

            <div
              className="field"
              onClick={() =>
                this.setState({
                  allowMultipleChoice: !this.state.allowMultipleChoice,
                })
              }
            >
              <input
                type="checkbox"
                className="switch"
                checked={this.state.allowMultipleChoice}
                onChange={() => {}}
              />
              <label>Allow multiple choice responses</label>
            </div>

            <div
              className="field"
              onClick={() =>
                this.setState({ allowOpenText: !this.state.allowOpenText })
              }
            >
              <input
                type="checkbox"
                className="switch"
                checked={this.state.allowOpenText}
                onChange={() => {}}
              />
              <label>Allow open text responses</label>
            </div>

            {this.state.allowOpenText && (
              <p className="help is-warning">
                Open text answers won't be neatly aggregated in the results
                section, but you'll be able to view individual answers from
                employees.
              </p>
            )}
          </div>
        </>
      );
    };

    const renderDeadlineSection = () => {
      return (
        <>
          <div className="field mt-6">
            <label className="label">Response Deadline</label>

            <p className="mb-4">
              No answers will be accepted after the response deadline as passed.
            </p>

            <div className="control">
              <label className="radio mr-4">
                <input
                  type="radio"
                  name="no_deadline"
                  checked={this.state.respondUntil === undefined}
                  onChange={() => this.setState({ respondUntil: undefined })}
                />
                &nbsp;&nbsp;No deadline
              </label>
              <label className="radio">
                <input
                  type="radio"
                  name="respondby"
                  checked={this.state.respondUntil !== undefined}
                  onChange={() =>
                    this.setState({
                      respondUntil: this.state.scheduleDate
                        ? moment(this.state.scheduleDate).add(1, "hours")
                        : moment().add(1, "hours"),
                    })
                  }
                />
                &nbsp;&nbsp;Deadline:
              </label>

              <label className="radio">
                <Datetime
                  inputProps={{
                    style: { textAlign: "center" },
                    disabled: this.state.respondUntil === undefined,
                  }}
                  value={
                    this.state._tmp_respondUntil || this.state.respondUntil
                  }
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm"
                  onChange={(date) => {
                    this.setState({ _tmp_respondUntil: date });
                    if (moment(date).isValid())
                      this.setState({ respondUntil: date });
                  }}
                />
              </label>
            </div>

            {this.state.respondUntil &&
              ((this.state.scheduleDate &&
                this.state.respondUntil.isSameOrBefore(
                  this.state.scheduleDate
                )) ||
                (!this.state.scheduleDate &&
                  this.state.respondUntil.isSameOrBefore(moment()))) && (
                <p className="help is-danger">
                  The response deadline must be after the scheduled time!
                </p>
              )}

            {this.state.respondUntil &&
              ((this.state.scheduleDate &&
                this.state.respondUntil.isAfter(this.state.scheduleDate)) ||
                (!this.state.scheduleDate &&
                  this.state.respondUntil.isAfter(moment()))) &&
              this.state.respondUntil.diff(this.state.scheduleDate, "minutes") <
                30 && (
                <p className="help is-warning">
                  The deadline is very close to the scheduled date. Make sure
                  the recipients have time to respond.
                </p>
              )}

            {this.state.isInteractive &&
              this.state.respondUntil &&
              this.state.ExpectedResponses.length === 0 &&
              !this.state.allowOpenText && (
                <p className="help is-danger">
                  You didn't add any expected responses or allowed open text
                  responses. The recipients won't know a response is expected!
                </p>
              )}
          </div>
        </>
      );
    };

    const renderForm = () => {
      return (
        <>
          <section className="section mx-6">
            <div className="container">
              {renderSpendingQuota()}

              {/* TITLE  */}
              <div className="field">
                <label className="label">Title</label>

                <p className="mb-4">
                  Give this notification a title in order to find it in the
                  results view. Recipients will not see this.
                </p>

                <div className="control">
                  <input
                    className="input "
                    type="text"
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    placeholder="Notification Title"
                  />
                </div>
              </div>

              {/* INTERACTICE NOTIFICATION  */}

              <div className="field mt-6">
                <label className="label">Recipient Interactivity</label>

                <div className="mb-4">
                  <p className="">
                    Are the receivers of this notification expected to respond
                    to it?
                  </p>
                  <small>
                    This will help us estimate the full length of the message to
                    be sent.
                  </small>
                </div>

                <div className="field" onClick={this.onToggleInteractivity}>
                  <input
                    type="checkbox"
                    className="switch"
                    checked={this.state.isInteractive}
                    onChange={() => {}}
                  />
                  <label>{this.state.isInteractive ? "Yes" : "No"}</label>
                </div>
              </div>

              {/* MESSAGE */}

              <div className="field mt-6">
                <label className="label">Message</label>

                <p className="mb-4">
                  Type the message to be sent. Remember that sending internet
                  links is highly risky.
                </p>
                <div className="control ">
                  <textarea
                    className="textarea "
                    rows="6"
                    placeholder="Message"
                    onChange={(e) => this.updateSmsLength(e.target.value)}
                    value={this.state.smsLnS.text}
                  ></textarea>
                </div>

                <p
                  className={`level-item help ${
                    this.state.smsLnS.smsCount === 1 ? "is-info" : "is-warning"
                  }`}
                >{`SMS Count: ${this.state.smsLnS.smsCount}.`}</p>
                <p
                  className={`level-item help ${
                    this.state.smsLnS.charsLeft > 0 ? "is-info" : "is-warning"
                  }`}
                >{`Characters left: ${this.state.smsLnS.charsLeft}.`}</p>

                {this.state.smsLnS.text &&
                  smsContainsUrl(this.state.smsLnS.text) && (
                    <p className="help is-danger">
                      Including internet links in SMS is a security risk. Please
                      avoid this if possible!
                    </p>
                  )}
              </div>

              {/* RESPONSES SECTION  */}

              {this.state.isInteractive && renderResponsesSection()}

              {/* DEALINE */}
              {this.state.isInteractive && renderDeadlineSection()}

              {/* SCHEDULE */}

              <div className="field mt-6">
                <label className="label">Schedule</label>

                <p className="mb-4">
                  Either send the notification now or schedule a time for it to
                  be sent later.
                </p>

                <div className="control">
                  <label className="radio mr-4">
                    <input
                      type="radio"
                      name="send_immediately"
                      checked={this.state.scheduleDate === undefined}
                      onChange={() =>
                        this.setState({ scheduleDate: undefined })
                      }
                    />
                    &nbsp;&nbsp;Send Immediately
                  </label>
                  <label className="radio">
                    <input
                      type="radio"
                      name="sendby"
                      checked={this.state.scheduleDate !== undefined}
                      onChange={() =>
                        this.setState({
                          scheduleDate: moment().add(1, "hours"),
                        })
                      }
                    />
                    &nbsp;&nbsp;Send at:
                  </label>

                  <label className="radio">
                    <Datetime
                      inputProps={{
                        style: { textAlign: "center" },
                        disabled: this.state.scheduleDate === undefined,
                      }}
                      value={
                        this.state._tmp_scheduleDate || this.state.scheduleDate
                      }
                      dateFormat="YYYY-MM-DD"
                      timeFormat="HH:mm"
                      onChange={(date) => {
                        this.setState({ _tmp_scheduleDate: date });
                        if (moment(date).isValid())
                          this.setState({ scheduleDate: date });
                      }}
                    />
                  </label>
                </div>
                {this.state.scheduleDate &&
                  this.state.scheduleDate.isBefore(moment()) && (
                    <p className="help is-danger">
                      The date must be in the future!
                    </p>
                  )}
              </div>

              {/* RECIPIENTS */}

              <div className="field mt-6">
                <label className="label">Recipients</label>

                <p className="mb-4">Select groups or individual recipients.</p>
                <p className="control is-inline-block is-align-content-center">
                  <button
                    className="button is-info is-small"
                    onClick={this.onSelectRecipients}
                  >
                    Select Recipients
                  </button>
                  <span className="ml-4">{`${this.state.recipientsCount} recipients selected.`}</span>
                </p>
              </div>

              <div className="container mt-6 has-text-centered">
                {renderSmsLimitWarning()}
              </div>

              <div className="container mt-6 has-text-centered">
                {this.state.__inputValidation.map((v) => (
                  <p
                    key={v}
                    className="help is-danger is-justify-content-center"
                  >
                    {v}
                  </p>
                ))}
              </div>

              <div className="buttons is-centered mt-4">
                <button
                  className={`button is-primary ${
                    this.state.isSubmitting ? "is-loading" : ""
                  }`}
                  onClick={this.onSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </section>
        </>
      );
    };

    const renderLogic = () => {
      if (!stats)
        return (
          <div className="is-flex is-justify-content-center mt-6 ">
            <Loading />
          </div>
        );

      if (stats) {
        return renderForm();
      }
    };

    return (
      <div>
        <section className="section mx-6">
          <div className="container sie-title-container">
            <h4 className="title">Siemens Mobility Instant Communication</h4>
            <h5 className="subtitle">SMS Notification System</h5>
          </div>
        </section>

        {renderLogic()}
      </div>
    );
  }
}

export default withRouter(NewNotification);
